import {
  TaskEither,
  Either,
  isLeft,
  left,
  right,
  isRight,
  taskEither,
  fetchData,
} from '@shared-commons/utils';
import { ErrorMessage } from '@/shared/utils';
import { lessonsValidator } from './lessons-validator';
import { Lessons } from '../../types/lessons';
import { LessonsAdapter } from './lessons-adapter';

export const getLearningPathByIdLessons = (
  email: string | undefined,
  learningPathDocumentId: string,
  accessToken: string | null,
): TaskEither<Error, Lessons> => {
  const validateLessons = (lessons: Lessons): Either<Error, Lessons> => {
    const validatedLessons = lessonsValidator(lessons);
    if (isLeft(validatedLessons)) {
      const errorMessage = new Error(validatedLessons?.value.message);
      return left(new Error(ErrorMessage('Validation error') + errorMessage));
    }
    return right(validatedLessons.value);
  };

  const adapter = (input: Lessons): TaskEither<Error, Lessons> => {
    const adaptTask: TaskEither<Error, Lessons> = async () => {
      try {
        const adaptedLessons = await LessonsAdapter(input)();
        if (isRight(adaptedLessons)) {
          return right(adaptedLessons?.value as Lessons);
        } else {
          throw new Error(adaptedLessons?.value.message);
        }
      } catch (error) {
        return left(
          new Error(ErrorMessage('Failed to adapt users') + ': ' + (error as Error).message),
        );
      }
    };

    return taskEither(adaptTask);
  };

  return fetchData<Lessons>(
    `${process.env.NEXT_PUBLIC_HOST}/api/learning-paths/learning-path-by-id/lessons/view?email=${email}&lessonDocumentId=${learningPathDocumentId}`,
    (input) => adapter(input),
    validateLessons,
    'GET',
    {
      Authorization: `Bearer ${accessToken}`,
    },
  );
};
